import img1 from './Rehabilitacion/img1.jpg'
import img2 from './Rehabilitacion/img2.jpg'
import img25 from './Rehabilitacion/img25.jpg'
import img26 from './Rehabilitacion/img26.jpg'
import img27 from './Rehabilitacion/img27.jpg'
import img29 from './Rehabilitacion/img29.jpg'
import img30 from './Rehabilitacion/img30.jpg'
import img31 from './Rehabilitacion/img31.jpg'
import img32 from './Rehabilitacion/img32.jpg'
import { Footer } from './Footer'
import React, { Component } from 'react'
import { Card, Pagination, Row, Col, Container } from 'react-bootstrap'
import { Navigation } from './Navigation'

export class Rehabilitacion extends Component {
    render() {
        const productos = [
            img1, img2, img26, img27, img29, img30, img25, img31, img32
        ];

        return (
            <div>
                <Navigation />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Rehabilitación</h1>
                        </Col>
                    </Row>
                    <br />

                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item active>{1}</Pagination.Item>
                        <Pagination.Item href="/rehabilitacion2">{2}</Pagination.Item>
                        <Pagination.Item href="/rehabilitacion3">{3}</Pagination.Item>
                    </Pagination>
                    <br />

                    {/* Cambio clave: lg={2} para maximizar el tamaño de la información */}
                    <Row xs={1} md={2} lg={2} className="g-5 text-center">
                        {productos.map((imagen, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow border-0">
                                    <Card.Body className="p-2">
                                        <Card.Img 
                                            variant="top" 
                                            src={imagen} 
                                            style={{ 
                                                height: '550px', // Altura aumentada para mejor lectura
                                                objectFit: 'contain',
                                                width: '100%'
                                            }} 
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <br />
                    <Pagination className="justify-content-center mt-5" size="lg">
                        <Pagination.Item active>{1}</Pagination.Item>
                        <Pagination.Item href="/rehabilitacion2">{2}</Pagination.Item>
                        <Pagination.Item href="/rehabilitacion3">{3}</Pagination.Item>
                    </Pagination>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}